import { fetchNgwLayerItemExtent } from "@nextgis/ngw-kit";

import type { NgwMapInstance, SearchField, SearchItem } from "../types";

export function getSearchFieldKeys(fields: SearchField[]): string[] {
  const visible = fields.filter((field) => field.grid_visibility);
  const label = fields.find((field) => field.label_field);
  const selected = visible.length
    ? visible
    : label
      ? [label]
      : fields.slice(0, 4);
  return selected.map((field) => field.keyname).filter(Boolean);
}

export function getSearchLabel(
  item: SearchItem,
  fields: SearchField[],
  fallback: (id: number) => string,
): string {
  const labelField = fields.find((field) => field.label_field);
  if (labelField && item.fields[labelField.keyname]) {
    return String(item.fields[labelField.keyname]);
  }

  for (const field of fields) {
    const value = item.fields[field.keyname];
    if (value !== null && value !== undefined && value !== "") {
      return String(value);
    }
  }

  return fallback(item.id);
}

export async function zoomToSearchItem(
  ngwMap: NgwMapInstance,
  resourceId: number,
  item: SearchItem,
): Promise<void> {
  const extent = await fetchNgwLayerItemExtent({
    connector: ngwMap.connector,
    resourceId,
    featureId: item.id,
  });
  if (extent) {
    ngwMap.fitBounds(extent, { maxZoom: 14 });
  }
}
